import React from 'react';
import { IVariantsProps } from '../types';
import { SizeVariantsDesktopVersion } from './size-variants-desktop-version';
import { SizeVariantsMobileVersion } from './size-variants-mobile-version';
import { MediumUpDevice, SmallOnlyDevice } from './styles';

export const SizeVariants: React.FC<IVariantsProps> = props => {
  return (
    <>
      <MediumUpDevice>
        <SizeVariantsDesktopVersion {...props} />
      </MediumUpDevice>
      <SmallOnlyDevice>
        <SizeVariantsMobileVersion {...props} />
      </SmallOnlyDevice>
    </>
  );
};
